import { queryClient } from '../../../ReactQuery';
import useToastedMutation from '../../../ReactQuery/useToastedMutation';
import { remove } from '../../../redux/api';
import { nuc } from '../../../utils';
import { getBaseDependencyFetchQueryKey } from '../dependencies/queryKey';
import type { RevisionLicenseConclusionScope } from '../../../../shared/model-typings/revisionlicenseconclusion';

type DeleteScopedConclusionParams = {
  dependencyRevisionLocator: string;
  scope: RevisionLicenseConclusionScope;
  scopeId: string;
};

const deleteScopedConclusion = async ({ dependencyRevisionLocator, scope, scopeId }: DeleteScopedConclusionParams) => {
  return remove(`/api/license-conclusions/${nuc(dependencyRevisionLocator)}`, { body: { scope, scopeId }, json: true });
};

/**
 * Hook for deleting a scoped license conclusion. Note that this does not support global or base conclusions.
 *
 * @param dependencyRevisionLocator The dependency revision locator.
 */
export const useDeleteScopedConclusion = (dependencyRevisionLocator: string) => {
  return useToastedMutation({
    mutationFn: ({ scope, scopeId }: DeleteScopedConclusionParams) =>
      deleteScopedConclusion({ dependencyRevisionLocator, scope, scopeId }),
    successToastMessage: 'License conclusions successfully reverted.',
    errorToastMessage: 'Failed to revert license conclusions.',
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: getBaseDependencyFetchQueryKey(dependencyRevisionLocator) });
    },
  });
};
